import React from 'react';
import { Modal } from 'react-bootstrap';

export default function SelectNoMeasurementsGrommet({
  pageLanguage,
  modals,
  modalHandleClose,
  t,
}) {
  return (
   <Modal
   dialogClassName={`noMount_modal mediumSizeModal ${
     pageLanguage === "fa" ? "font_farsi" : "font_en"
   }`}
   show={modals["noMeasurements"] === undefined ? false : modals["noMeasurements"]}
   onHide={() => modalHandleClose("noMeasurements")}
 >
   <Modal.Header closeButton></Modal.Header>
   <Modal.Body>
     <p>{t("modal_select_noMeasurements")}</p>

     <br />
     <div className=" text_center">
       <button
         className=" btn btn-new-dark"
         onClick={() => modalHandleClose("noMeasurements")}
       >
         {t("CONTINUE")}
       </button>
     </div>
   </Modal.Body>
 </Modal>
  )
}
